import { Identifiable, Toggleable } from '@editor/interfaces/attribute'
import { Points } from 'three'

export interface PointCloudProps extends Toggleable, Identifiable {
  pcd: Points
}

/**
 * PointCloud component to render .pcd point clouds in the 3D canvas.
 * Currently, only supports Three.js Points object (loaded via PCDLoader).
 * If Potree format is needed, it will be expanded in the future.
 */
const PointCloud = ({ id, pcd, visible = true }: PointCloudProps) => (
  <primitive name={id} object={pcd} visible={visible} />
)

export default PointCloud
